// Shared error state — built once, used by both screens (root CLAUDE.md:
// "Loading, empty, and error states — built, not deferred"). Never renders
// a raw server error string; `messageId` is always a shared/i18n id that
// the caller has already mapped an ApiError.code to.
//
// When the caller also passes the `error` it caught (an ApiError from
// shared/api/client.js, or a TanStack Query `query.error`), the code the
// API returned is shown beneath the message — a user should not have to
// open devtools to know what failed. The full response is logged to the
// console in development by the api client itself.

import { useLanguage } from '../context/LanguageContext.jsx';
import styles from './ErrorState.module.css';

export default function ErrorState({
  titleId = 'state.errorTitle',
  messageId = 'state.errorGeneric',
  error,
  onRetry,
}) {
  const { t } = useLanguage();
  // `error` is the ApiError the caller caught (or a TanStack Query
  // `query.error`, which is that same ApiError). We surface only its `code`
  // — never `error.body` or `error.message`, which can carry a raw server
  // string (root CLAUDE.md).
  const code = error && error.code ? error.code : null;

  return (
    <div className={styles.wrapper} role="alert">
      <p className={styles.title}>{t(titleId)}</p>
      <p className={styles.message}>{t(messageId)}</p>
      {code && (
        <p className={styles.code}>
          {t('error.codeLabel')}: <span>{code}</span>
        </p>
      )}
      {onRetry && (
        <button type="button" className={styles.retryButton} onClick={onRetry}>
          {t('state.retry')}
        </button>
      )}
    </div>
  );
}
